import { call, put, takeLatest, all } from 'redux-saga/effects'
import api from 'services/api'
import {
	getDocumentsByStatus,
	getDocumentsByStatusSuccess,
	getDocumentsByStatusFailure,
} from './index'

function* getDocumentsByStatusSaga() {
	try {
		const response = yield call(api.get, '/workflow/documents-by-status')

		if (response && response.data) {
			yield put(getDocumentsByStatusSuccess(response.data))
		} else {
			throw new Error('A resposta da API está vazia ou mal formatada.')
		}
	} catch (error) {
		yield put(getDocumentsByStatusFailure(error.message))
	}
}

export function* workflowSaga() {
	yield all([takeLatest(getDocumentsByStatus.type, getDocumentsByStatusSaga)])
}
